import {PlusIcon} from '@primer/octicons-react'
import {Button, IconButton} from '@primer/react'
import {useState} from 'react'

import {BUTTON_LABELS} from '../../constants/buttons'

const LOADING_ANNOUNCEMENT = 'Loading...'

type CreateIssueButtonShellProps = {
  iconOnly?: boolean
}

/**
 * Lightweight shell that mirrors the visual appearance of
 * `@github-ui/issue-create/CreateIssueButton` without pulling in its heavy
 * dependency graph.  Used as the Suspense fallback so users see a real button
 * instead of nothing while the full component lazy-loads.
 *
 * Clicking the shell triggers the lazy chunk and puts the button into a
 * loading state until React swaps in the real component.
 */
export function CreateIssueButtonShell({iconOnly = false}: CreateIssueButtonShellProps = {}) {
  const [clicked, setClicked] = useState(false)
  const handleClick = () => setClicked(true)

  if (iconOnly) {
    return (
      <IconButton
        size="medium"
        icon={PlusIcon}
        aria-label={BUTTON_LABELS.new}
        loading={clicked}
        loadingAnnouncement={LOADING_ANNOUNCEMENT}
        onClick={handleClick}
      />
    )
  }

  return (
    <Button
      size={'medium'}
      variant={clicked ? 'default' : 'primary'}
      loading={clicked}
      loadingAnnouncement={LOADING_ANNOUNCEMENT}
      onClick={handleClick}
    >
      {BUTTON_LABELS.new}
    </Button>
  )
}
